import { useState, useCallback, useEffect } from 'react';
import Drawer from '../Drawer';

const AddGrantDrawer: React.FC<Props> = ({ isOpen, setIsOpen }) => {
    const resetAndCloseForm = () => {
        setIsOpen(false);
    };

    return (
        <Drawer isOpen={isOpen} setIsOpen={setIsOpen}>
            <h2 className='mb-[28px] text-[22px]/[28px] font-bold'>
                Add Grant
            </h2>

            <label className='text-[12px]/[14px] font-extrabold'>
                Grant Name{' '}
                <span className='mb-[3px] text-[10px]/[10px] text-[#F02D3A]'>
                    *
                </span>
            </label>
            <div className='mb-[5px] flex rounded-lg border border-[#949599] p-[10px]'>
                <input className='w-full' type='text' />
            </div>

            <div className='mt-[30px]'>
                <button
                    className='m-auto mr-3 justify-self-end rounded-3xl border-[2px] border-black bg-white px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase hover:bg-black hover:text-white'
                    onClick={resetAndCloseForm}
                >
                    Cancel
                </button>
                <button
                    className='m-auto mr-3 rounded-full bg-[#FEBF3E] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-[#131212] hover:bg-opacity-90'
                    onClick={resetAndCloseForm}
                >
                    Save
                </button>
            </div>
        </Drawer>
    );
};

export default AddGrantDrawer;
